import { NamedEntityDto } from './named.dto';

export class ApproximateAgeDto extends NamedEntityDto {}
